/* eslint-disable react/prop-types */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { DEFAULT_TIME_ZONE_NAME } from '@shared/constants';
import Close from '@espaceProImages/icon-close.inline.svg';
import { FONT_FAMILY_MAIN, TEXT_COLOR } from '../../theme';
import { Slots } from './Slots';
import { SeparateSlots } from './SeparateSlots';

const Title = styled.div`
  font-family: ${FONT_FAMILY_MAIN};
  font-size: 16px;
  font-weight: bold;
  line-height: 1.5;
  letter-spacing: 0.2px;
  color: ${TEXT_COLOR};
  margin: 16px 0;
`;

const ErrorMessage = styled.div`
  font-size: 12px;
  height: 20px;
  margin: 0 40px 10px;
  color: #f74656;
`;

const Container = styled.div`
  display: flex;
  ${(props) => (props.isTitleAtTheTop ? 'flex-direction: column;' : 'flex-direction: row')}
  width: 100%;
  padding-top: ${(props) => (props.title ? '0' : '16px')};
`;

const CloseIcon = styled(Close)`
  position: absolute;
  top: 16px;
  right: 16px;
  width: 24px;
  height: 24px;
  cursor: pointer;
`;

class BookingCalendar extends Component {
  componentDidMount() {
    gtag('event', 'old-booking-form-slots-step-view', {
      event_category: 'Code de la route',
      event_label: 'Form slots step',
    });
  }

  render() {
    const {
      slots,
      onSlotClick,
      onClickNavLeft,
      onClickNavRight,
      isLeftNavVisible,
      isRightNavVisible,
      errorMessage,
      timeZoneName,
      title = '',
      isSeparateSlots,
      titlePosition = 'aside',
      isCloseButtonVisible,
      onClose,
      localPage,
      maxLocalPages,
    } = this.props;

    const isMobile = window.innerWidth < 576;

    return (
      <Container title={title} isTitleAtTheTop={titlePosition === 'top'}>
        <div>
          <Title>{title}</Title>
          {isCloseButtonVisible && <CloseIcon fill="#ccd0d4" onClick={onClose} />}
        </div>
        {isSeparateSlots || isMobile ? (
          <SeparateSlots
            onClickNavLeft={onClickNavLeft}
            isLeftNavVisible={isLeftNavVisible}
            onClickNavRight={onClickNavRight}
            isRightNavVisible
            slots={slots}
            onSlotClick={onSlotClick}
            timeZoneName={timeZoneName}
            emptyText="Nous n'avons pas trouvé de session d'examen à ces dates."
            localPage={localPage}
            maxLocalPages={maxLocalPages}
          />
        ) : (
          <Slots
            onClickNavLeft={onClickNavLeft}
            isLeftNavVisible={isLeftNavVisible}
            onClickNavRight={onClickNavRight}
            isRightNavVisible={isRightNavVisible}
            slots={slots}
            onSlotClick={onSlotClick}
            timeZoneName={timeZoneName}
            emptyText="Nous n'avons pas trouvé de session d'examen à ces dates."
          />
        )}
        {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
      </Container>
    );
  }
}

BookingCalendar.propTypes = {
  slots: PropTypes.object,
  onSlotClick: PropTypes.func,
  onClickNavLeft: PropTypes.func,
  isLeftNavVisible: PropTypes.bool,
  onClickNavRight: PropTypes.func,
  isRightNavVisible: PropTypes.bool,
  errorMessage: PropTypes.string,
  timeZoneName: PropTypes.string,
};

BookingCalendar.defaultProps = {
  slots: {},
  onSlotClick: () => {},
  onClickNavLeft: () => {},
  isLeftNavVisible: true,
  onClickNavRight: () => {},
  isRightNavVisible: true,
  errorMessage: '',
  timeZoneName: DEFAULT_TIME_ZONE_NAME,
};

export default BookingCalendar;
